import styled from 'styled-components'

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  gap: 0.5rem;
  text-align: center;
  img {
    width: 100px;
    height: auto;
  }
`
